import { gql } from '@apollo/client';

export const GET_ALL_PREDEFINED_AVATARS = gql`
  query getAllPredefinedAvatars {
    getAllPredefinedAvatars {
      id
      type
      status
      name
      fileId
      description
      validTill
      organizations
      tenants
      starCost
      genders
      category
      isEnabledForAllOrgs
    }
  }
`;

export type DeleteAvatarsResponse = {
  deleteAvatar: {
    success: boolean;
    errorFileIds: string[];
  };
};

export const DELETE_AVATARS = gql`
  mutation DeleteAvatar($fileIds: [UUID!]!) {
    deleteAvatar(fileIds: $fileIds) {
      success
      errorFileIds
    }
  }
`;

export type PreDefinedAvatarsOutput = {
  id: string;
  type: string;
  status: string;
  name: string;
  fileId: string;
  description: string;
  validFrom: string;
  validTill?: string;
  organizations: string[];
  tenants: string[];
  starCost: number;
  genders: string[];
  category: string;
  isEnabledForAllOrgs: boolean;
};

export type AvatarHistoryResponse = {
  getAllPredefinedAvatars: PreDefinedAvatarsOutput[];
};

export const UPDATE_AVATAR_STATUS = gql`
  mutation UpdateAvatarStatus($avatarId: UUID!, $status: AvatarStatus!) {
    updateAvatarStatus(avatarId: $avatarId, status: $status) {
      message
    }
  }
`;
